import React, { FC, useMemo } from 'react'
import { Collapse } from 'components/Collapse'

import { filterFollowOptions, formatUserList } from 'modulesCommon/Filters/utils'
import { FilterArchived, FilterButtonGroup, FilterList, FilterWrapper } from '..'

import { ARCHIVED_FILTER_OPTIONS, FILTER_FIELDS, FOLLOWED_FILTER_OPTIONS } from 'shared/consts/filter'

import { FilterProjectsProps } from './FilterProjects.props'
import { useReactiveVar } from '@apollo/client'
import { spaceIdVar } from 'modulesCommon/store'
import './FilterProjects.scss'

const FilterProjects: FC<FilterProjectsProps> = ({
  unitsOptions,
  users,
  filterEntities,
  isShownMyFilter,
  initialValues,
  defaultValue,
  projectsTotal,
  spacesOptions = []
}) => {
  const updatedUsers = useMemo(() => formatUserList(users), [users])
  const spaceId = useReactiveVar(spaceIdVar)

  return (
    <FilterWrapper
      selectionLabels={{
        followed: FOLLOWED_FILTER_OPTIONS,
        unit_id: unitsOptions,
        owners: updatedUsers,
        archived: ARCHIVED_FILTER_OPTIONS,
        label_id: spacesOptions
      }}
      total={`${projectsTotal} projects`}
      filterEntities={filterEntities}
      initialValues={initialValues}
      defaultValue={defaultValue}
      render={({ updateValue, resetValues, shouldBeReset, values }) => (
        <div className="project-filters-container">
          <div>
            <FilterButtonGroup
              options={filterFollowOptions(FOLLOWED_FILTER_OPTIONS, isShownMyFilter)}
              initialValue={values.followed}
              defaultValue={defaultValue.followed}
              onSelect={updateValue(FILTER_FIELDS.FOLLOWED)}
              onReset={resetValues}
              reset={shouldBeReset}
              dataTest="project-filters-followed"
            />
          </div>
          <Collapse list={[
            ...!spaceId ? [{
              title: 'Select Unit',
              id: '1',
              content: (
                <FilterList
                  onReset={resetValues}
                  onSelect={updateValue(FILTER_FIELDS.UNITS)}
                  options={[
                    {
                      label: 'All units',
                      value: 'all'
                    },
                    ...unitsOptions
                  ]}
                  initialValue={values.unit_id}
                  defaultValue={defaultValue.unit_id}
                  reset={shouldBeReset}
                />),
              expand: false
            }] : [],
            ...spacesOptions.length ? [{
              title: 'Select Zone',
              id: '1',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.LABELS)}
                  onReset={resetValues}
                  options={[
                    {
                      label: 'All Zones',
                      value: 'all'
                    },
                    ...spacesOptions
                  ]}
                  initialValue={values.label_id}
                  defaultValue={defaultValue.label_id}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            }] : [],
          ]}>
          </Collapse>
          <FilterArchived
            onSelect={updateValue(FILTER_FIELDS.ARCHIVED)}
            onReset={resetValues}
            initialValue={values.archived}
            reset={shouldBeReset}
          />
        </div>
      )}
    />
  )
}

export default FilterProjects
